import { router } from '@/router'

import { logs } from './router/logs'

export function appendLogsRoutes() {
  for (const log of logs) {
    // const l = router.resolve({ path: log.path })
    if (!router.hasRoute(log.name as string)) {
      console.log('[appendLogsRoutes] Logs installRouter')
      router.addRoute(log)
    }
  }
}
